module.exports = __webpack_public_path__ + "static/Spinach-&-Feta-Pesto-43afaffbd2097a564b7b1ac661c11abc.png";